import { FC } from 'react';
import { BooleanInput, Edit, EditProps, required, SimpleForm, TextInput } from 'react-admin';

export const DesignationEdit: FC<EditProps> = () => (
  <Edit mutationMode="pessimistic">
    <SimpleForm>
      <TextInput source="name" validate={required()} />
      <BooleanInput source="default" />
    </SimpleForm>
  </Edit>
);
